import { Button } from '../../components/button/index.ts';
import Stack from '@mui/material/Stack';
import { FullLogoSvg } from '../../assets/icons/full-logo-svg.tsx';
import { Typography, useTheme } from '@mui/material';
import { ArrowIcon } from '../../assets/icons/arrow.tsx';
import { useNavigate } from 'react-router';
import { Path } from '../../assets/enums/index.ts';
import { BlurContainer, JuicyTypography } from '../../components/index.ts';
import { useGameSessionContext } from '../../assets/helpers/hooks/index.ts';
import { PlayerIcon } from '../../assets/icons/player.tsx';
import { LogoutIcon } from '../../assets/icons/logout.tsx';

export const HomePage = () => {
  const { palette } = useTheme();
  const nav = useNavigate();
  const { gameSessionParams, clearGameSessionContext } = useGameSessionContext();
  return (
    <Stack height={'100%'} py={8}>
      <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <FullLogoSvg />
        {gameSessionParams?.phoneNumber &&
          <BlurContainer direction={'row'} alignItems={'center'} gap={4} onClick={() => clearGameSessionContext()}>
            <PlayerIcon style={{ width: '64px', height: '64px' }} color={palette.accent} />
            <Typography variant={'body'} color={palette.accent}>{gameSessionParams.phoneNumber}</Typography>
            <LogoutIcon  color={palette.white_100} />
          </BlurContainer>
        }
      </Stack>

      <Stack mt={'auto'} gap={14}>

        <BlurContainer>
          <JuicyTypography>
            Your Short Game Is About to Get More Rewarding
          </JuicyTypography>
          <Typography mr={40} variant={'title'} color={palette.white_90}>
            Stick it close or ace it —
            win up to $20,000!
          </Typography>
        </BlurContainer>



        <Button sx={{ alignItems: 'start' }} onClick={() => nav(Path.GameSettings)}>
          <Stack width="100%" direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
            <Typography variant={'button'}>Start Your Challenge</Typography>
            <ArrowIcon />
          </Stack>
          <Typography mt={4} variant={'description'}>
            Takes less than 30 seconds
          </Typography>
        </Button>

      </Stack>

      <Typography mt={8} variant={'description'} color={palette.white_60} textAlign={'center'}>Must be 18+ to
        play</Typography>

    </Stack>
  );
};
